// extracted by mini-css-extract-plugin
export default {"link":"sK-z","disabled":"tK-z"};